import { Navigate, useParams } from 'react-router';
import { MediaKitPackView } from './MediaKitPackView';

export function MediaKitPackPage() {
  const { packId } = useParams<{ packId: string }>();
  const id = Number(packId);

  if (!Number.isInteger(id) || id <= 0) return <Navigate to="/media-kit" replace />;

  // Keyed by pack: per-button download states and a running ZIP poll belong to
  // one pack and must not carry over to the next.
  return <MediaKitPackView key={id} packId={id} />;
}
